@use '@/styles/tokens' as *;

/* Figma 1322:689046 (My location, y=654) over 1322:689041 (the zoom pair, y=703) — bottom right of
 * the map area. Absolute inside the map AREA, NOT inside the map: that is what keeps the controls
 * fixed while the Grower pans and zooms (113584 §4a).
 *
 * `z-index: 2` clears the canvas and stays FAR below antd's overlay base of 1000, which is the
 * load-bearing half — a recovery modal (ticket 14) must render over the map and be fully operable
 * there.
 *
 * `MAP_CONTROL_LAYOUT` in src/lib/maps/control-zones.ts repeats these four numbers — SCSS cannot
 * import TS, so the two sides name each other. Change one, change both. */
.stack {
  position: absolute;
  /* Figma: 32px from the bottom edge, 63px from the right. */
  bottom: var(--space-8);
  inset-inline-end: var(--space-16);
  z-index: 2;
  display: flex;
  flex-direction: column;
  /* Figma 13px between My location and the zoom pair (703 - 690); --space-3 is the nearest token. */
  gap: var(--space-3);
}

/* The zoom pair reads as one cluster, at Figma's own 6px (y=0 → y=42). No --space-* token sits at 6;
 * 8 loosens the pair out of reading as one control. */
.group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

/* Shared button box: 36px square, 20px glyph, the project focus ring (113584 §4b). No size token
 * exists at 36; Figma's px-8/py-5 padding round-trips to the same box. */
.control,
.locate {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  padding: 0;
  border: none;
  cursor: pointer;

  &:focus-visible {
    outline: none;
    box-shadow: var(--focus-ring);
  }
}

/* Figma 1322:689042 / 1322:689044 — dark translucent square, white glyph. */
.control {
  border-radius: $radius-md;
  background: var(--overlay-60);
  color: var(--text-inverse);

  &:hover:not(:disabled) {
    /* No Figma frame covers hover; the next step on the same overlay ramp. */
    background: var(--overlay-80);
  }

  /* No Figma frame covers the limit state (113584 §6c). Muted + not-allowed is the shipped disabled
   * idiom (see text-button.module.scss); the `disabled` attribute does the rest. */
  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }
}

/* Figma 1322:689046 — light circular button, dark glyph. The odd one out in the stack: Surface/Base
 * (#FCFCF7 → --surface-page) with a Text/Primary (#111111 → --text-primary) GpsFix glyph, and
 * `rounded-[48px]` on a 36px box, which is a circle.
 *
 * Deliberately NO `:disabled` rule: 113583 §14a and 113584 §9a require this control enabled in every
 * permission state, and §6b forbids any distinct treatment marking a refusal. There is no state in
 * which it is unavailable, so there is no style for one. */
.locate {
  border-radius: $radius-pill;
  background: var(--surface-page);
  color: var(--text-primary);

  &:hover {
    background: $color-control-hover;
  }
}
